import heroBackgroundLqip from '@/assets/food/hero-background-1.25x.jpg?lqip'
import heroBackgroundImg from '@/assets/food/hero-background-1.25x.jpg?minW=1024&picture-image-tools'
import heroBackgroundMobileLqip from '@/assets/food/hero-background-mobile-1.25x.jpg?lqip'
import heroBackgroundMobileImg from '@/assets/food/hero-background-mobile-1.25x.jpg?minW=420&picture-image-tools'
import Picture from '@/components/Picture'
import BetterSuspense from '@/utils/components/BetterSuspense'
import FoodGrubhubInput from '@/views/FoodGrubhub/components/FoodGrubhubSearchWithAutoComplete/FoodGrubhubInput'

// import FoodGrubhubSearchWithAutoComplete from '@/views/FoodGrubhub/components/FoodGrubhubSearchWithAutoComplete/FoodGrubhubSearchWithAutoComplete'
import style from './FoodGrubhubDefaultContent.module.scss'

interface SearchInputControl {
  setSearchInput: MemoizedCallbackOrDispatch<string>
  submit: () => void
  focus: () => void
}

export default function FoodGrubhubDefaultContent() {
  const searchControl = useRef<SearchInputControl>(null)

  const handleSearchReady = useCallback(() => {
    searchControl.current?.focus()
  }, [])

  const handleSearchSubmit = useCallback(() => {
    searchControl.current?.submit()
  }, [searchControl])

  return (
    <div className={style.PageContainer}>
      <div className={style.HeroContainer}>
        <Picture
          src={[
            {
              pic: heroBackgroundImg,
              lqip: heroBackgroundLqip,
              // media: 'min-width: 64rem',
              media: 'min-width: 48rem',
            },
            {
              pic: heroBackgroundMobileImg,
              lqip: heroBackgroundMobileLqip,
              // media: 'max-width: 63.9375rem',
              media: 'max-width: 47.9375rem',
            },
          ]}
          fetchPriority='high'
          alt=''
          className={clsx(style.Hero)}
          preload
        />
        <div className={style.BlurLayer}></div>
        <div className={style.HeroContent}>
          <h1 className={style.Heading}>Food & Grocery Delivery</h1>
          <div className={style.SearchContainer}>
            <BetterSuspense fallback={<div aria-hidden='true' />} onReady={handleSearchReady}>
              {/* <FoodGrubhubSearchWithAutoComplete /> */}
              <FoodGrubhubInput
                control={searchControl}
                placeholderText='Enter your delivery address'
                variant='main'
              />
              <button
                onClick={handleSearchSubmit}
                type='button'
                className={style.SearchBtn}
                aria-hidden='true'
                tabIndex={-1}
              >
                Search
              </button>
            </BetterSuspense>
          </div>
        </div>
      </div>
    </div>
  )
}
